import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { merge } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorLookupComponent } from '../../../Lookup/vendor-lookup/vendor-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UnitsOfMeasure, Warehouse } from '../../../../model/administration.model';
import { Department, GSTInfo, POReturnChargeFormFields, Product, ProductPOReturn, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { AdministratorService } from '../../../../services/administrator.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesService } from '../../../../services/sales.service';
import { LoaderComponent } from '../../../loader/loader.component';
import _, { create } from 'lodash';
import { CustomerService } from '../../../../services/customer.service';
import { InventoryService } from '../../../../services/inventory.service';
import { viewproductLookupComponent } from '../../../Lookup/viewproduct-lookup/viewproduct-lookup.component';
import { VendorService } from '../../../../services/vendor.service';
import { CloseQuickProductLookupComponent } from '../../../Lookup/close-quick-product-lookup/close-quick-product-lookup.component';
import { POCommentsLookupComponent } from '../../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { ListLinkedFilesLookupComponent } from '../../../Lookup/List-Linked-Files-lookup/list-linked-files.lookup.component';
import { CloseQuickVendorLookupComponent } from '../../../Lookup/close-quick-vendor-lookup/close-quick-vendor-lookup.component';
import { UOMLookupComponent } from '../../../Lookup/uomlookup/uomlookup.component';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';
import { PurchaseOrderReceiptLookupComponent } from '../../../Lookup/purchase-order-receipt-lookup/purchase-order-receipt-lookup.component';
import { gstOnNet, isTaxableFlag, lineAmount, lineTotalFromNetAndGst, netFromAmountAndPercent, round2, } from '../../../../shared/discount-percent.util';

@Component({
  selector: 'app-create-purchaseorder',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-returnpurchaseorder.component.html',
  styleUrl: './create-returnpurchaseorder.component.scss'
})
export class CreateReturnPurchaseorderComponent implements OnInit {
  @ViewChild('productCodeInputRef') productCodeInputRef!: any;

  status: string | undefined;
  loader: boolean = false;
  selectedProduct: ProductPOReturn[] = [];
  purchaseOrderId: any;
  purchaseOrderLineItemId: any;
  submitted: any;
  warehouseDropdown: any[] = [];
  departmentDropdown: any[] = [];
  filtewarehouse: Warehouse[] = [];
  filterDepartments: Department[] = [];
  filterProductList: any[] = [];
  products: ProductPOReturn[] = [];
  manualEntryChecked: boolean = false;
  deleteProductIds: any[] = [];
  previewImage: string = "./assets/no-image.jpg";
  isEditMode: boolean = false;
  addProductData: any;
  allProductData: ProductPOReturn[] = [];
  GSTList: GSTInfo[] = [];
  hsncode: any;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  orderTotal: number = 0;
  weightTotal: number = 0.00;
  POLineItemData: any;
  TaxTotal: number = 0;
  lineTaxableTotal: number = 0;
  private skipFreightProration = false;
  productCostCalculationType: string | undefined;
  isIGST: boolean = false;
  vendorState: string | undefined;
  warehouseState: string | undefined;
  ReceiptList: any[] = [];
  VendorList: any[] = [];
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  userList: any;
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  productId: any;
  QAvail: number = 0;
  projectData: any;
  projectBoMId: any;
  statusF: any;
  visible: boolean = false;
  comment: any;
  isPOLimitWarning: boolean = false;
  POLimit: number = 0;
  adminUser: any;
  selectedVendorId: any;
  receiptNumber: any;
  statusPOReturn: any;
  returnPurchaseOrderIds: any;
  statusMessage: string = '';
  filteredReceiptList: any[] = [];
  VendorName: any;
  unitLabel: string = '';
  FinalTaxableAmt = 0;
  FreightAmount = 0;
  PackingForwarding = 0;
  isGlPosted = false;
  glEntries: any[] = [];
  glTotalDebit = 0;
  glTotalCredit = 0;
  activeIndex = 0;
  private userHasEditedCharges = false;

  private grnChargeBaseline = {
    freight: 0,
    pf: 0,
    freightRate: 0,
    pfRate: 0,
    lineNet: 0,
  };

  gstOptions = [
    { label: 'GST0 - (0%)', value: 0 },
    { label: 'GST5 - (5%)', value: 5 },
    { label: 'GST12 - (12%)', value: 12 },
    { label: 'GST18 - (18%)', value: 18 },
    { label: 'GST28 - (28%)', value: 28 },
  ];

  constructor(public dialogService: DialogService, public ref: DynamicDialogRef, private warehouseService: AdministratorService,
    private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService,
    private salesService: SalesService, private inventoryService: InventoryService, private customerService: CustomerService, private porderservice: PurchaseorderService,
    private el: ElementRef, private vendorService: VendorService) { }

  ngOnInit(): void {
    this.purchaseOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.purchaseOrderLineItemForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.adminUser = localStorage.getItem('username');
    document.title = 'Create Purchase Return';
    this.getWarehouse(this.pageRequest);
    this.getUserList();
    this.getDepartment(this.pageRequest);
    this.editPurchaseOrder();
    this.startTypingAnimation();
    const currentDate = new Date();

    this.purchaseOrderForm.get('returnDate')?.valueChanges.subscribe(date => {
      if (date) {
        this.onTransactionDateChange(date);
      }
    });

    // this.route.queryParams.subscribe(params => {

    //   this.receiptNumber = params['returnPurchaseOrderId']; // <-- use your actual query param
    //   this.isEditMode = !!this.receiptNumber;

    //   if (this.isEditMode) {

    //     document.title = 'Update Purchase Return';

    //     // Load existing Purchase Return
    //     this.editPurchaseOrder();

    //   }
    //   else {

    //     // Create Mode
    //     this.purchaseOrderForm.patchValue({
    //       //returnDate: currentDate,
    //       requestedDate: currentDate,
    //       createdDate: currentDate
    //     });

    //     // Load Financial Year for today's date
    //     this.onTransactionDateChange(currentDate);
    //   }

    //   // Financial Year based on Return Date
    //   this.purchaseOrderForm.get('returnDate')?.valueChanges.subscribe(date => {
    //     if (date) {
    //       //this.onTransactionDateChange(date);
    //     }
    //   });

    // });


    this.purchaseOrderForm.controls.createdDate.setValue(currentDate);
    this.getUnitLabel();
    this.getDeptLabel();
    this.bindChargeFieldRecalculation();
  }

  private bindChargeFieldRecalculation(): void {
    const streams = [
      this.purchaseOrderForm.get('FreightAmount')?.valueChanges,
      this.purchaseOrderForm.get('GSTRateOnFreight')?.valueChanges,
      this.purchaseOrderForm.get('PackingForwarding')?.valueChanges,
      this.purchaseOrderForm.get('GSTRateOnPNF')?.valueChanges,
    ].filter((s): s is NonNullable<typeof s> => !!s);

    merge(...streams)
      .pipe(debounceTime(150))
      .subscribe(() => this.recalcChargeFooter(true));
  }

  recalcChargeFooter(manualEdit = false): void {
    if (manualEdit) {
      this.userHasEditedCharges = true;
      this.skipFreightProration = true;
    }
    this.calculateFreightGST();
    this.calculatePFGST();
    void this.calculateOrderTotal().finally(() => {
      this.skipFreightProration = false;
    });
  }

  placeholder: string = 'Search By Product ';
  private messages: string[] = [
    'Code',
    'Name',
  ];
  currentMessageIndex: number = 0;
  currentCharIndex: number = 0;
  typingInterval: any;
  waitTimeout: any;
  DeptLabel: string = '';


  ngOnDestroy() {
    clearInterval(this.typingInterval);
    clearTimeout(this.waitTimeout);
  }

  startTypingAnimation() {
    this.typingInterval = setInterval(() => {
      if (this.currentCharIndex < this.messages[this.currentMessageIndex].length) {
        this.placeholder += this.messages[this.currentMessageIndex][this.currentCharIndex];
        this.currentCharIndex++;
      } else {
        clearInterval(this.typingInterval);
        this.waitTimeout = setTimeout(() => {

          this.currentCharIndex = 0;
          this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
          this.placeholder = 'Search By Product ';
          this.startTypingAnimation();
        }, 1000);
      }
    }, 200);
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  purchaseOrderForm = new FormGroup({
    receiptNumber: new FormControl('', [Validators.required]),
    warehouses: new FormControl(),
    receiveDate: new FormControl<Date | null>(null, Validators.required),
    // returnDate: new FormControl('', Validators.required),
    returnDate: new FormControl<Date | null>(null, Validators.required),
    challanDate: new FormControl<Date | null>(null),
    challenNo: new FormControl(),
    warehouseId: new FormControl(),
    warehouseCode: new FormControl(),
    warehouseName: new FormControl('', Validators.required),
    warehouseAddress: new FormControl(''),
    unitSerial: new FormControl(''),
    requestedDate: new FormControl(new Date()),
    amendmentDate: new FormControl(),
    poTotal: new FormControl(),
    SGSTtotal: new FormControl(),
    CGSTtotal: new FormControl(),
    IGSTTotal: new FormControl(),
    TaxTotal: new FormControl(),
    vendor: new FormControl(),
    vendorName: new FormControl(''),
    vendorId: new FormControl(),
    vendorCode: new FormControl('', Validators.required),
    add: new FormControl(),
    departments: new FormControl(),
    departmentId: new FormControl('', Validators.required),
    departmentCode: new FormControl(),
    departmentName: new FormControl('', Validators.required),
    termsCode: new FormControl(),
    specialInstruction: new FormControl(),
    purchaseOrderComment: new FormControl(''),
    totalWeight: new FormControl(),
    isActive: new FormControl(true),
    CreatedBy: new FormControl(),
    manualEntry: new FormControl(true),
    PurchaseOrder_Status: new FormControl('Draft'),
    Taxes: new FormControl(''),
    Delivery: new FormControl(''),
    createdDate: new FormControl(),
    poNumber: new FormControl(),
    ProjectBoMId: new FormControl(''),
    projectBoMName: new FormControl(),
    Freight: new FormControl(''),
    FreightAmount: new FormControl<number | null>(0, { nonNullable: true }),
    PackingForwarding: new FormControl<number | null>(0, { nonNullable: true }),
    GSTRateOnFreight: new FormControl(0),
    GSTRateOnPNF: new FormControl(0),
    GSTOnFreight: new FormControl(0),
    GSTOnPNFAmount: new FormControl(0),
    FinalTaxableAmt: new FormControl(0),
    FinancialYearId: new FormControl(),
  })

  purchaseOrderLineItemForm = new FormGroup({
    receiptNumber: new FormControl(''),
    returnPurchaseOrderId: new FormControl(),
    ReceivedQuantity: new FormControl(''),
    ReturnQuantity: new FormControl(''),
    RejectedQuantity: new FormControl(''),
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productWgt: new FormControl(''),
    productData: new FormControl(''),
    Cost: new FormControl(''),
    Uom: new FormControl(''),
    ExtendedCost: new FormControl(''),
    GSTRate: new FormControl(''),
    CGST: new FormControl(''),
    SGST: new FormControl(''),
    IGST: new FormControl(''),
    PurchaseOrderComment: new FormControl(''),
    ReturnPurchaseOrder_Status: new FormControl(''),
    IsActive: new FormControl(''),
    IsSpecialOrder: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
  })

  autosearchReceipts(event: any) {
    this.porderservice.searchPOReceiptReturnPO(event.query).subscribe(
      (data: any) => {
        if (data) {
          let filteredList = data.filter(
            (receipt: any) => receipt.poReceiptStatus === 'Close'
          );
          if (this.VendorName) {
            filteredList = filteredList.filter(
              (receipt: any) => receipt.vendor.vendorName === this.VendorName
            );
          }
          this.ReceiptList = filteredList;
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to search receipts' });
        console.error(error);
      }
    );
  }

  setReceiptNumber(event: any) {
    if (event && event.value) {
      const selectedReceipt = event.value;
      this.purchaseOrderForm.controls['receiptNumber'].setValue(selectedReceipt.poReceiptNumber);
      this.purchaseOrderForm.controls['receiptNumber'].markAsTouched();
      this.purchaseOrderForm.controls['receiptNumber'].markAsDirty();
      this.purchaseOrderForm.controls['receiptNumber'].updateValueAndValidity();

      const receiveDate = selectedReceipt.receiveDate ? new Date(selectedReceipt.receiveDate) : null;
      this.purchaseOrderForm.controls['receiveDate'].setValue(receiveDate);

      let challanDate: Date | null = null;
      if (selectedReceipt.challenDate) {
        const parsedDate = new Date(selectedReceipt.challenDate);
        challanDate = isNaN(parsedDate.getTime()) ? null : parsedDate;
      }

      this.purchaseOrderForm.controls['challanDate'].setValue(challanDate);

      this.purchaseOrderForm.controls['challenNo'].setValue(selectedReceipt.challenNo);
      this.purchaseOrderForm.controls['poNumber'].setValue(selectedReceipt.purchaseOrderNumber);

      if (selectedReceipt.warehouse) {
        this.purchaseOrderForm.patchValue({
          warehouseName: selectedReceipt.warehouse.warehouseName,
          warehouseId: selectedReceipt.warehouse.warehouseId,
          warehouseAddress: selectedReceipt.warehouse.address
            ? `${selectedReceipt.warehouse.address.addressLine1}, ${selectedReceipt.warehouse.address.city} ${selectedReceipt.warehouse.address.state}, ${selectedReceipt.warehouse.address.country}, ${selectedReceipt.warehouse.address.zip}`
            : ''
        });

        const warehouseNameControl = this.purchaseOrderForm.get('warehouseName');
        if (warehouseNameControl) {
          warehouseNameControl.markAsTouched();
          warehouseNameControl.markAsDirty();
          warehouseNameControl.updateValueAndValidity();
        }
      }

      if (selectedReceipt.department) {
        this.purchaseOrderForm.patchValue({
          departmentId: selectedReceipt.department.departmentId,
          departmentName: selectedReceipt.department.departmentName
        });

        const departmentIdControl = this.purchaseOrderForm.get('departmentId');
        if (departmentIdControl) {
          departmentIdControl.markAsTouched();
          departmentIdControl.markAsDirty();
          departmentIdControl.updateValueAndValidity();
        }

        const departmentNameControl = this.purchaseOrderForm.get('departmentName');
        if (departmentNameControl) {
          departmentNameControl.markAsTouched();
          departmentNameControl.markAsDirty();
          departmentNameControl.updateValueAndValidity();
        }
      }

      if (selectedReceipt.vendor) {
        this.purchaseOrderForm.patchValue({
          vendorName: selectedReceipt.vendor.vendorName,
          vendorId: selectedReceipt.vendor.vendorId,
          vendorCode: selectedReceipt.vendor.vendorCode,
          add: selectedReceipt.vendor.address
            ? `${selectedReceipt.vendor.address.addressLine1},${selectedReceipt.vendor.address.city} ${selectedReceipt.vendor.address.state}, ${selectedReceipt.vendor.address.country},${selectedReceipt.vendor.address.zip}`
            : '',
          termsCode: selectedReceipt.vendor.termsCode
        });

        this.vendorState = this.normalizeState(selectedReceipt.vendor.address?.state);
        this.selectedCustomerEmail = selectedReceipt.vendor.email;
        this.selectedCustomerName = selectedReceipt.vendor.vendorName;
      }

      if (selectedReceipt.warehouse) {
        this.warehouseState = this.normalizeState(selectedReceipt.warehouse.address?.state);
      }

      this.purchaseOrderForm.updateValueAndValidity();

      this.loadReceiptLinesAndCharges(selectedReceipt.poReceiptNumber, selectedReceipt);
    }
  }

  private loadReceiptLinesAndCharges(poReceiptNumber: string, receiptContext?: any): void {
    if (receiptContext) {
      this.applyStatesFromReceiptSelection(receiptContext);
    }

    this.porderservice.getPOReceiptHeaderByReceiptNumber(poReceiptNumber).subscribe({
      next: (header: any) => {
        this.applyStatesFromReceiptHeader(header);
        this.porderservice.getPOReceiptLineitem(poReceiptNumber).subscribe({
          next: (lineItemsData: any) => {
            this.products = this.loadProducts(lineItemsData);
            this.allProductData = this.products;
            this.grnChargeBaseline.lineNet = this.computeGrnLineNetTotal(lineItemsData);
            this.resolveIsIGSTMode(true);
            this.applyGrnChargesFromHeader(header);
          },
          error: (error: any) => console.log('Error fetching purchase order lineitems:', error),
        });
      },
      error: () => {
        if (receiptContext) {
          this.applyGrnChargesFromHeader(receiptContext);
        }
        this.porderservice.getPOReceiptLineitem(poReceiptNumber).subscribe({
          next: (lineItemsData: any) => {
            this.products = this.loadProducts(lineItemsData);
            this.allProductData = this.products;
            this.grnChargeBaseline.lineNet = this.computeGrnLineNetTotal(lineItemsData);
            this.resolveIsIGSTMode(true);
            void this.calculateOrderTotal();
          },
        });
      },
    });
  }

  private normalizeState(state: string | null | undefined): string {
    return (state ?? '').trim();
  }

  private applyStatesFromReceiptSelection(receipt: any): void {
    if (!receipt) {
      return;
    }
    const vendorState = receipt.vendor?.address?.state;
    const warehouseState = receipt.warehouse?.address?.state;
    if (vendorState) {
      this.vendorState = this.normalizeState(vendorState);
    }
    if (warehouseState) {
      this.warehouseState = this.normalizeState(warehouseState);
    }
  }

  private applyStatesFromReceiptHeader(header: any): void {
    if (!header) {
      return;
    }
    const vendorState = header.vendor?.address?.state ?? header.Vendor?.address?.state;
    const warehouseState = header.warehouse?.address?.state ?? header.Warehouse?.address?.state;
    if (vendorState) {
      this.vendorState = this.normalizeState(vendorState);
    }
    if (warehouseState) {
      this.warehouseState = this.normalizeState(warehouseState);
    }
  }

  private applyGrnChargesFromHeader(header: any): void {
    if (!header) {
      void this.calculateOrderTotal();
      return;
    }

    this.applyStatesFromReceiptHeader(header);

    const grnFreight = this.num(header.freightAmount ?? header.FreightAmount);
    const grnPf = this.num(header.packingForwarding ?? header.PackingForwarding);
    const grnFreightRate = this.num(header.gstRateOnFreight ?? header.GSTRateOnFreight);
    const grnPfRate = this.num(header.gstRateOnPNF ?? header.GSTRateOnPNF);

    this.grnChargeBaseline = {
      freight: grnFreight,
      pf: grnPf,
      freightRate: grnFreightRate,
      pfRate: grnPfRate,
      lineNet: this.grnChargeBaseline.lineNet,
    };

    if (grnFreight > 0 || grnPf > 0) {
      this.userHasEditedCharges = false;
      this.FreightAmount = grnFreight;
      this.PackingForwarding = grnPf;
      this.purchaseOrderForm.patchValue({
        Freight: header.freight ?? header.Freight ?? '',
        FreightAmount: grnFreight,
        PackingForwarding: grnPf,
        GSTRateOnFreight: grnFreightRate,
        GSTRateOnPNF: grnPfRate,
      }, { emitEvent: false });
      this.calculateFreightGST();
      this.calculatePFGST();
    } else {
      this.userHasEditedCharges = true;
    }

    void this.calculateOrderTotal();
  }

  private computeGrnLineNetTotal(lines: any[]): number {
    if (!lines?.length) {
      return 0;
    }
    return lines.reduce((sum, item) => {
      const qty = this.num(item.receivedQuantity ?? item.ReceivedQuantity);
      const cost = this.num(item.cost ?? item.Cost);
      const disc = this.num(item.discount ?? item.Discount);
      const gross = qty * cost;
      return sum + netFromAmountAndPercent(gross, disc);
    }, 0);
  }

  private prorateGrnCharges(returnLineNet: number): { freight: number; pf: number } {
    const base = this.grnChargeBaseline.lineNet;
    const ratio = base > 0 ? Math.min(1, returnLineNet / base) : 0;
    return {
      freight: round2(this.grnChargeBaseline.freight * ratio),
      pf: round2(this.grnChargeBaseline.pf * ratio),
    };
  }

  private num(v: any): number {
    return _.toNumber(v) || 0;
  }

  private parseChargeInput(val: unknown): number {
    const parsed = parseFloat(String(val ?? '').replace(/[₹,\s]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private emptyChargeFormFields(): POReturnChargeFormFields {
    return {
      Freight: '',
      FreightAmount: 0,
      PackingForwarding: 0,
      GSTRateOnFreight: 0,
      GSTRateOnPNF: 0,
      GSTOnFreight: 0,
      GSTOnPNFAmount: 0,
      FinalTaxableAmt: 0,
      poTotal: 0,
      TaxTotal: 0,
      CGSTtotal: 0,
      SGSTtotal: 0,
      IGSTTotal: 0,
      totalWeight: 0,
    };
  }

  private chargeFieldsFromApi(header: any): POReturnChargeFormFields {
    if (!header) {
      return this.emptyChargeFormFields();
    }
    return {
      Freight: header.freight ?? header.Freight ?? '',
      FreightAmount: this.num(header.freightAmount ?? header.FreightAmount),
      PackingForwarding: this.num(header.packingForwarding ?? header.PackingForwarding),
      GSTRateOnFreight: this.num(header.gstRateOnFreight ?? header.GSTRateOnFreight),
      GSTRateOnPNF: this.num(header.gstRateOnPNF ?? header.GSTRateOnPNF),
      GSTOnFreight: this.num(header.gstOnFreight ?? header.GSTOnFreight),
      GSTOnPNFAmount: this.num(header.gstOnPNFAmount ?? header.GSTOnPNFAmount),
      FinalTaxableAmt: this.num(header.finalTaxableAmt ?? header.FinalTaxableAmt),
      poTotal: this.num(header.poTotal ?? header.POTotal),
      TaxTotal: this.num(header.taxTotal ?? header.TaxTotal),
      CGSTtotal: this.num(header.cgstTotal ?? header.CGSTTotal),
      SGSTtotal: this.num(header.sgstTotal ?? header.SGSTTotal),
      IGSTTotal: this.num(header.igstTotal ?? header.IGSTTotal),
      totalWeight: this.num(header.totalWeight ?? header.TotalWeight),
    };
  }

  private applySavedChargeFieldsFromApi(header: any): void {
    const charges = this.chargeFieldsFromApi(header);
    this.FreightAmount = this.num(charges.FreightAmount);
    this.PackingForwarding = this.num(charges.PackingForwarding);
    this.purchaseOrderForm.patchValue(charges, { emitEvent: false });
  }

  private mapReturnHeaderForApi(formValue: any): any {
    const raw = this.purchaseOrderForm.getRawValue();

    return {
      ...formValue,
      returnPurchaseOrderId:
        formValue.returnPurchaseOrderId ?? this.returnPurchaseOrderIds ?? this.purchaseOrderId,
      receiptNumber: formValue.receiptNumber ?? this.receiptNumber,
      FreightAmount: this.num(raw.FreightAmount),
      PackingForwarding: this.num(raw.PackingForwarding),
      GSTRateOnFreight: this.num(raw.GSTRateOnFreight),
      GSTRateOnPNF: this.num(raw.GSTRateOnPNF),
      GSTOnFreight: this.num(raw.GSTOnFreight),
      GSTOnPNFAmount: this.num(raw.GSTOnPNFAmount),
      FinalTaxableAmt: this.FinalTaxableAmt,
      POTotal: this.orderTotal,
      TaxTotal: this.TaxTotal,
      CGSTTotal: this.CGSTtotal,
      SGSTTotal: this.SGSTtotal,
      IGSTTotal: this.IGSTtotal,
      Freight: raw.Freight ?? '',
    };
  }


  calculateFreightGST(): void {
    const freight = this.parseChargeInput(this.purchaseOrderForm.get('FreightAmount')?.value);
    const rate = this.num(this.purchaseOrderForm.get('GSTRateOnFreight')?.value);
    const gst = round2((freight * rate) / 100);
    this.purchaseOrderForm.patchValue({ GSTOnFreight: gst }, { emitEvent: false });
  }

  calculatePFGST(): void {
    const pf = this.parseChargeInput(this.purchaseOrderForm.get('PackingForwarding')?.value);
    const rate = this.num(this.purchaseOrderForm.get('GSTRateOnPNF')?.value);
    const gst = round2((pf * rate) / 100);
    this.purchaseOrderForm.patchValue({ GSTOnPNFAmount: gst }, { emitEvent: false });
  }

  private clearLineAmounts(product: ProductPOReturn): void {
    product.ExtendedCost = 0;
    product.NetAmount = 0;
    product.CGST = 0;
    product.SGST = 0;
    product.IGST = 0;
    product.LineTotal = 0;
    product.SalesTax = 0;
  }

  private applyProratedFreightToForm(returnLineNet: number): void {
    if (this.skipFreightProration
      || this.userHasEditedCharges
      || this.grnChargeBaseline.lineNet <= 0
      || returnLineNet <= 0) {
      return;
    }

    const prorated = this.prorateGrnCharges(returnLineNet);
    this.purchaseOrderForm.patchValue(
      {
        FreightAmount: prorated.freight,
        PackingForwarding: prorated.pf,
        GSTRateOnFreight: this.grnChargeBaseline.freightRate,
        GSTRateOnPNF: this.grnChargeBaseline.pfRate,
      },
      { emitEvent: false }
    );
    this.calculateFreightGST();
    this.calculatePFGST();
  }

  autosearchVendor(event: any) {
    this.vendorService.autoSearchVendor(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.VendorList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to search vendor' });
        console.log(error);
      }
    );
  }

  setVendor(vendor: any) {
    if (vendor) {
      this.purchaseOrderForm.patchValue({
        vendorName: vendor.vendorName,
        vendorId: vendor.vendorId,
        vendorCode: vendor.vendorCode,
        add: `${vendor.address.addressLine1},${vendor.address.city} ${vendor.address.state}, ${vendor.address.country},${vendor.address.zip}`
      });
      this.VendorName = vendor.vendorName,
        this.vendorState = this.normalizeState(vendor.address?.state);
      this.selectedCustomerEmail = vendor.email;
      this.selectedCustomerName = vendor.vendorName;
    }
  }

  openPOListLookup() {
    const ref = this.dialogService.open(PurchaseOrderReceiptLookupComponent, {
      header: 'Purchase Receipt List',
      width: '80%',
      data: { selectedCustomerName: this.selectedCustomerName, isReturnPO: true }
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      let challanDate: Date | null = null;
      if (selectedCustomer.challenDate) {
        const parsedDate = new Date(selectedCustomer.challenDate);
        challanDate = isNaN(parsedDate.getTime()) ? null : parsedDate;
      }
      if (selectedCustomer) {
        const receiveDate = selectedCustomer.receiveDate ? new Date(selectedCustomer.receiveDate) : null;
        this.purchaseOrderForm.controls.receiptNumber.setValue(selectedCustomer.poReceiptNumber);
        this.purchaseOrderForm.controls.receiveDate.setValue(receiveDate);
        this.purchaseOrderForm.controls.challanDate.setValue(challanDate);
        this.purchaseOrderForm.controls.challenNo.setValue(selectedCustomer.challenNo);
        this.purchaseOrderForm.controls.poNumber.setValue(selectedCustomer.purchaseOrderNumber);

        if (selectedCustomer.warehouse) {
          this.purchaseOrderForm.patchValue({
            warehouseName: selectedCustomer.warehouse.warehouseName,
            warehouseId: selectedCustomer.warehouse.warehouseId,
            warehouseAddress: selectedCustomer.warehouse.address
              ? `${selectedCustomer.warehouse.address.addressLine1}, ${selectedCustomer.warehouse.address.city} ${selectedCustomer.warehouse.address.state}, ${selectedCustomer.warehouse.address.country}, ${selectedCustomer.warehouse.address.zip}`
              : ''
          });

          const warehouseNameControl = this.purchaseOrderForm.get('warehouseName');
          if (warehouseNameControl) {
            warehouseNameControl.markAsTouched();
            warehouseNameControl.markAsDirty();
            warehouseNameControl.updateValueAndValidity();
          }
        }

        if (selectedCustomer.department) {
          this.purchaseOrderForm.patchValue({
            departmentId: selectedCustomer.department.departmentId,
            departmentName: selectedCustomer.department.departmentName
          });

          const departmentIdControl = this.purchaseOrderForm.get('departmentId');
          if (departmentIdControl) {
            departmentIdControl.markAsTouched();
            departmentIdControl.markAsDirty();
            departmentIdControl.updateValueAndValidity();
          }

          const departmentNameControl = this.purchaseOrderForm.get('departmentName');
          if (departmentNameControl) {
            departmentNameControl.markAsTouched();
            departmentNameControl.markAsDirty();
            departmentNameControl.updateValueAndValidity();
          }
        }

        if (selectedCustomer.vendor) {
          this.purchaseOrderForm.patchValue({
            vendorName: selectedCustomer.vendor.vendorName,
            vendorId: selectedCustomer.vendor.vendorId,
            vendorCode: selectedCustomer.vendor.vendorCode,
            add: `${selectedCustomer.vendor.address.addressLine1},${selectedCustomer.vendor.address.city} ${selectedCustomer.vendor.address.state}, ${selectedCustomer.vendor.address.country},${selectedCustomer.vendor.address.zip}`,
            termsCode: selectedCustomer.vendor.termsCode
          });
          this.vendorState = this.normalizeState(selectedCustomer.vendor?.address?.state);
          this.selectedCustomerEmail = selectedCustomer.vendor.email;
          this.selectedCustomerName = selectedCustomer.vendor.vendorName;
        }

        if (selectedCustomer.warehouse) {
          this.warehouseState = this.normalizeState(selectedCustomer.warehouse?.address?.state);
        }

        this.purchaseOrderForm.updateValueAndValidity();

        this.loadReceiptLinesAndCharges(selectedCustomer.poReceiptNumber, selectedCustomer);
      }
    });
  }

  performAction(action: any) {
    const data = this.purchaseOrderForm?.value;

    if (data) {
      if (this.isEditMode) {
        switch (action) {
          case 'Save':
            data.PurchaseOrder_Status = 'Draft';
            this.statusMessage = 'Saved';
            break;
          case 'Approve':
            data.PurchaseOrder_Status = 'Open';
            this.statusMessage = 'Approved';
            break;
          case 'Close':
            data.PurchaseOrder_Status = 'Closed';
            this.statusPOReturn = 'Closed';
            this.statusMessage = 'Closed';
            break;
          default:
            this.statusMessage = 'updated';
        }
        this.updatePO(data);
      } else {
        this.statusMessage = 'created';
        this.createPO(data);
      }
    } else {
      console.error("Form data is null or undefined");
    }
  }

  async createPO(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    const productsWithReturnQty = this.products.filter(product => {
      const returnQty = Number(product.ReturnQuantity) || 0;
      return returnQty > 0;
    });

    if (productsWithReturnQty.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please enter return quantity for at least one product.'
      });
      return;
    }

    for (const product of productsWithReturnQty) {
      const rejectedQty = Number(product.RejectedQuantity) || 0;
      const receivedQty = Number(product.ReceivedQuantity) || 0;
      const returnQty = Number(product.ReturnQuantity) || 0;

      const maxAllowedQty = rejectedQty > 0 ? rejectedQty : receivedQty;

      if (returnQty > maxAllowedQty) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: `Return quantity (${returnQty}) cannot exceed ${rejectedQty > 0 ? 'rejected' : 'received'} quantity (${maxAllowedQty}) for product ${product.ProductCode}`
        });
        return;
      }
    }

    for (const product of this.products) {
      try {
        const validProductId = product.ProductId || this.productId;
        if (!validProductId) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Product', detail: 'Product ID is missing.' });
          this.loader = false;
          return;
        }
        const productData = await this.getProductById(validProductId);
        const costCalculationType = productData.costCalculation || 'Qty';

        if (Number(product.ReturnQuantity) > 0) {
          if (costCalculationType === 'Qty') {
            if (product.ReturnQuantity <= 0) {
              this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Return Quantity must be greater than 0.' });
              return;
            }
          } else if (costCalculationType === 'Wgt') {
            if (product.Weight <= 0) {
              this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
              return;
            }
          }
        }
      } catch (error) {
        console.error('Error fetching product data:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch product data.' });
        return;
      }
    }

    for (const product of this.products) {
      if (!product.ProductDescription) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Product Name is Required' });
        return;
      }
    }

    this.loader = true;

    try {
      await this.calculateOrderTotal();
      Object.assign(data, this.purchaseOrderForm.getRawValue());

      if (data.challanDate) {
        const currentTime = new Date();
        data.challanDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.receiveDate) {
        const currentTime = new Date();
        data.receiveDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.returnDate) {
        const currentTime = new Date();
        data.returnDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.createdDate) {
        const currentTime = new Date();
        data.createdDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.requestedDate && data.createdDate) {
        const requestedDateWithoutTime = new Date(data.requestedDate);
        const createdDateWithoutTime = new Date(data.createdDate);

        requestedDateWithoutTime.setHours(0, 0, 0, 0);
        createdDateWithoutTime.setHours(0, 0, 0, 0);

        if (requestedDateWithoutTime < createdDateWithoutTime) {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Invalid Date Range',
            detail: 'The requested date cannot be earlier than the order date.'
          });
          return;
        }
      }

      data.CreatedBy = data.CreatedBy || localStorage.getItem('username');
      data.createdDate = data.createdDate || new Date();

      // Ensure FinancialYearId is sent
      data.FinancialYearId = this.purchaseOrderForm.get('FinancialYearId')?.value;

      // if (!data.FinancialYearId) {
      //   this.loader = false;
      //   this.messageService.add({
      //     severity: 'error',
      //     summary: 'Financial Year',
      //     detail: 'Financial Year is required.'
      //   });
      //   return;
      // }

      // console.log("FinancialYearId:", data.FinancialYearId);
      // console.log("Payload:", this.mapReturnHeaderForApi(data));

      const createPOResponse = await this.porderservice
        .createPOReturn(this.mapReturnHeaderForApi(data))
        .toPromise();
      if (createPOResponse) {
        const returnPurchaseOrderId = createPOResponse.data.returnPurchaseOrderId;

        this.POLineItemData = this.POLineItemData.map((item: any) => ({
          ...item,
          returnPurchaseOrderId
        }));

        await this.createPOrderLineItem(this.POLineItemData);
        // this.sendOrderEmail();
      }
    } catch (error) {
      console.error('Error creating purchase order:', error);
      this.loader = false;
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Purchase Order.' });
    }
  }

  async createPOrderLineItem(data: any) {
    const promises: Promise<any>[] = [];
    this.loader = true;

    const linesWithReturnQty = data.filter(
      (product: any) => (Number(product.ReturnQuantity) || 0) > 0
    );

    for (const product of linesWithReturnQty) {
      const productData = { ...product };
      const createPromise = this.porderservice.createPOReturnLineItem(productData).toPromise();
      promises.push(createPromise);

      const returnQty = Number(product.ReturnQuantity) || 0;
      if (returnQty > 0) {
        createPromise.then(
          (data: any) => {
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Purchase Order Line Item.' });
            console.log(error);
            this.loader = false;
          }
        );
      } else {
        createPromise.then(
          (data: any) => {
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Purchase Order Return Line Item.' });
            console.log(error);
            this.loader = false;
          }
        );
      }
    }

    await Promise.all(promises);

    this.loader = false;
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Return Created Successfully.' });

    setTimeout(() => {
      this.router.navigate(['/home/Return-PO-List']);
    }, 1000);
  }

  updateInventory(ProductData: any) {
    const data = this.purchaseOrderForm.value;
    const productId = ProductData.ProductId || this.productId;

    const Inventory: UpdateInventory = <UpdateInventory>{
      productId: productId,
      warehouseId: data.warehouseId,
      productCode: ProductData.ProductCode,
      status: "Return PO",
      transactionType: "Return PO",
      transactionNo: data.receiptNumber,
      quantity: ProductData.ReturnQuantity,
      uom: ProductData.Uom, 
      unitCost: 0,
      createdBy: localStorage.getItem('username'),
      transactionDate: new Date(),
      createdDate: new Date(),
    }

    this.inventoryService.updateInventory(Inventory).subscribe({
      next: (data: any) => {
        // Inventory update successful
      },
      error: error => {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Error occurred while updating PO in Inventory.'
        });
      }
    });
  }


  async updatePO(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      return;
    }

    const productsWithReturnQty = this.products.filter(product => {
      const returnQty = Number(product.ReturnQuantity) || 0;
      return returnQty > 0;
    });

    if (productsWithReturnQty.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please enter return quantity for at least one product.'
      });
      return;
    }

    for (const product of productsWithReturnQty) {
      const rejectedQty = Number(product.RejectedQuantity) || 0;
      const receivedQty = Number(product.ReceivedQuantity) || 0;
      const returnQty = Number(product.ReturnQuantity) || 0;

      const maxAllowedQty = rejectedQty > 0 ? rejectedQty : receivedQty;

      if (returnQty > maxAllowedQty) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: `Return quantity (${returnQty}) cannot exceed ${rejectedQty > 0 ? 'rejected' : 'received'} quantity (${maxAllowedQty}) for product ${product.ProductCode}`
        });
        return;
      }
    }

    this.loader = true;

    if (this.deleteProductIds && this.deleteProductIds.length > 0) {
      this.porderservice.deletePOReturnLineitem(this.deleteProductIds).subscribe({
        next: (data: any) => { },
        error: error => { console.log(error); }
      });
    }

    try {
      const actionStatus = data.PurchaseOrder_Status;
      await this.calculateOrderTotal();
      Object.assign(data, this.purchaseOrderForm.getRawValue());

      //FyId
      data.FinancialYearId = this.purchaseOrderForm.get('FinancialYearId')?.value;
      console.log('FinancialYearId:', data.FinancialYearId);
      console.log('Payload:', data);

      if (actionStatus) {
        data.PurchaseOrder_Status = actionStatus;
      }

      const currentTime = new Date();

      if (data.challanDate) {
        data.challanDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.receiveDate) {
        data.receiveDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.returnDate) {
        data.returnDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.createdDate) {
        data.createdDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.amendmentDate) {
        data.amendmentDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }

      if (data.amendmentDate && data.requestedDate) {
        const amendmentDateWithoutTime = new Date(data.amendmentDate);
        const requestedDateWithoutTime = new Date(data.requestedDate);
        amendmentDateWithoutTime.setHours(0, 0, 0, 0);
        requestedDateWithoutTime.setHours(0, 0, 0, 0);

        if (amendmentDateWithoutTime < requestedDateWithoutTime) {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Invalid Amendment Date',
            detail: 'Amendment date cannot be earlier than the requested date.'
          });
          return;
        }
      }

      const promises: Promise<any>[] = [];

      for (const product of this.products) {
        product.ReceiptNumber = this.receiptNumber;
        product.returnPurchaseOrderId = this.returnPurchaseOrderIds;
        if (product.purchaseOrderReturnLineItemId !== undefined && product.purchaseOrderReturnLineItemId !== null) {
          let username: any = localStorage.getItem('username');
          product.UpdatedBy = username;
          const updatePromise = this.porderservice.updatePOReturnLineItem(product).toPromise();
          promises.push(updatePromise);

        } else {
          if (product.DateRequired instanceof Date) {
            product.DateRequired.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
          }
          const createPromise = this.porderservice.createPOReturnLineItem(product).toPromise();
          promises.push(createPromise);

        }
      }

      await Promise.all(promises);

      data.returnPurchaseOrderId = this.purchaseOrderId;
      data.UpdatedBy = localStorage.getItem('username');

      if (data) {
        this.porderservice.updatePurchaseOrderReturn(this.mapReturnHeaderForApi(data)).subscribe({
          next: (id: number) => {
            this.porderservice.getPurchaseOrderRetunById(id).subscribe((poReturn: any) => {
              if (poReturn.purchaseOrder_Status === 'Closed') {
                for (const product of productsWithReturnQty) {
                  this.updateInventory(product);
                }
                this.loader = false;
                const finalMessage = `Purchase Order Return ${this.statusMessage || 'Updated'} Successfully.`;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: finalMessage });

                this.glPostAfterApprove(this.returnPurchaseOrderIds);
                return;
              }

              this.loader = false;
              const finalMessage = `Purchase Order Return ${this.statusMessage || 'Updated'} Successfully.`;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: finalMessage });
              setTimeout(() => {
                this.router.navigate(['/home/Return-PO-List']);
              }, 1000);
            });
          },
          error: error => {
            console.error('Error updating PurchaseOrders:', error);
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while Updating Purchase Order.' });
            this.loader = false;
          }
        });
      }
    } catch (error) {
      console.error('Error updating purchase order:', error);
      this.loader = false;
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Update Purchase Order.' });
    }
  }

  createPOrder(data: any) {
    this.porderservice.createPOReturn(data).subscribe({
      next: (data: any) => {
        this.createPOrderLineItem(this.POLineItemData)
      },
      error: error => {
        console.log(error);
      }
    });
  }

  updatePOrder(data: any) {
    data.returnPurchaseOrderId = this.purchaseOrderId
    if (data) {
      this.porderservice.updatePurchaseOrderReturn(data).subscribe({
        next: responseData => {
          this.createPOrderLineItem(this.POLineItemData)
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Return Updated Successfully.' });
          this.router.navigate(['/home/Return-PO-List']);
        },
        error: error => {
          console.error('Error updating PurchaseOrders:', error);
        }
      });
    } else {
      this.createPOrder(data);
    }
  }


  updatePOrderLineItem(data: any) {
    if (data) {
      this.porderservice.updatePOReturnLineItem(data).subscribe({
        next: data => {
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Lineitem Updated Successfully.' });
        },
        error: error => {
          console.error('Error updating PurchaseOrders:', error);
        }
      });
    } else {
      this.createPOrderLineItem(data);
    }
  }

  getWarehouse(query: gridPageRequest) {
    this.warehouseService.getAllWarehouse(query).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
      }
    });
  }

  filteWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouses = (this.warehouseDropdown as any[])[i];
      if (warehouses.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        warehouses.warehouseName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(warehouses);
      }
    }
    this.filtewarehouse = filtered;
  }

  SelectedWarehouse(event: any) {
    if (event && event.value) {
      const selectedWarehouse = event.value;
      this.purchaseOrderForm.controls['warehouseCode'].setValue(selectedWarehouse.warehouseCode);
      this.purchaseOrderForm.controls['warehouseId'].setValue(selectedWarehouse.warehouseId);
      this.purchaseOrderForm.controls['warehouseName'].setValue(selectedWarehouse.warehouseName);
      this.purchaseOrderForm.controls['unitSerial'].setValue(selectedWarehouse.unitSerial);  // Set unitSerial
      this.warehouseState = this.normalizeState(selectedWarehouse.address?.state);
      const address = `${selectedWarehouse.address.addressLine1} , ${selectedWarehouse.address.city} , ${selectedWarehouse.address.state} , ${selectedWarehouse.address.country} , ${selectedWarehouse.address.zip}`;
      this.purchaseOrderForm.controls.warehouseAddress.setValue(address);
    }
  }


  getVendor() {
    this.ref = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          vendorName: data.vendorName,
          vendorId: data.vendorId,
          vendorCode: data.vendorCode,
          add: `${data.address.addressLine1},${data.address.city} ${data.address.state}, ${data.address.country},${data.address.zip}`,
          termsCode: data.termsCode
        });
        this.VendorName = data.vendorName,
          this.vendorState = data.address.state;
        this.selectedCustomerEmail = data.email;
        this.selectedCustomerName = data.vendorName;


      }
    });
  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          termsCode: data.paymentTermsDescription
        })
      }
    })
  }

  getDepartment(query: gridPageRequest) {
    this.porderservice.getDepartment(query).subscribe({
      next: (data: any) => {
        this.departmentDropdown = data.department;
        if (!this.isEditMode) {
          if (data.department) {
            this.purchaseOrderForm.controls['departmentCode'].setValue(data.department[0].departmentCode);
            this.purchaseOrderForm.controls['departmentId'].setValue(data.department[0].departmentId);
            this.purchaseOrderForm.controls['departmentName'].setValue(data.department[0].departmentName);
          }
        }
      }
    });
  }

  filterDepartment(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < (this.departmentDropdown as any[]).length; i++) {
      let departments = (this.departmentDropdown as any[])[i];
      if (departments.departmentCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        departments.departmentName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(departments);
      }
    }
    this.filterDepartments = filtered;
  }

  SelectedDepartment(event: any) {
    if (event && event.value) {
      const SelectedDepartment = event.value;
      this.purchaseOrderForm.controls['departmentCode'].setValue(SelectedDepartment.departmentCode);
      this.purchaseOrderForm.controls['departmentId'].setValue(SelectedDepartment.departmentId);
      this.purchaseOrderForm.controls['departmentName'].setValue(SelectedDepartment.departmentName);
    }
  }

  get formControls() {
    return this.purchaseOrderForm.controls;
  }

  Cancel() {
    this.router.navigate(['/home/Return-PO-List']);
  }

  validateForm() {
    let isValid = true;
    if (this.purchaseOrderForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }

  setProduct(data: any) {
    this.purchaseOrderLineItemForm.controls.productCode.setValue(data.value.productCode);
    this.purchaseOrderLineItemForm.controls.productDescription.setValue(data.value.productName);
    this.purchaseOrderLineItemForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;

    const costCalculationType = data.value.costCalculation;
    this.productCostCalculationType = costCalculationType || 'Qty';

    if (costCalculationType === 'Qty') {
      this.purchaseOrderLineItemForm.controls.productQty.setValue('');
    } else if (costCalculationType === 'Wgt') {
      this.purchaseOrderLineItemForm.controls.productWgt.setValue('');
    }
    this.setFieldFocus();

    if (data.value.productImage) {
      this.previewImage = `data:image/jpeg;base64,${data.value.productImage}`;
    } else {
      this.previewImage = "./assets/no-image.jpg";
    }
    this.getInventoryStatus(data.value.productCode);
  }

  setFieldFocus() {
    const control = this.el.nativeElement.querySelector('#Qty');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }

  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
        }
      },
      (error: any) => {
      }
    );
  }

  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(this.productId || productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  async onProductEdit(editData: any) {
    const index = this.products.findIndex(product =>
      product.LineItemNumber === editData.LineItemNumber);

    if (index === -1) {
      console.error('Product not found', editData);
      return;
    }

    const maxAllowed = editData.RejectedQuantity > 0 ? editData.RejectedQuantity : editData.ReceivedQuantity;
    if (editData.ReturnQuantity > maxAllowed) {
      console.warn(`Return Quantity exceeds allowed limit for line ${editData.LineItemNumber}`);
      editData.validationError = `Return Quantity cannot exceed ${maxAllowed}`;
      return;
    } else {
      editData.validationError = null;
    }

    if (!editData.Discount) {
      editData.Discount = 0;
    }

    const productId = editData.ProductId;
    let costCalculationType: string;

    try {
      const productData = await this.getProductById(productId);
      costCalculationType = productData.costCalculation || 'Qty';
    } catch (error) {
      console.error('Failed to fetch product data:', error);
      this.loader = false;
      return;
    }

    const qty = _.toNumber(editData.ReturnQuantity);
    const wgt = _.toNumber(editData.Weight);
    const cost = _.toNumber(String(editData.Cost).replace(/[₹,]/g, ''));
    const discPct = _.toNumber(editData.Discount) || 0;

    let updatedProduct: ProductPOReturn;
    if (qty <= 0) {
      updatedProduct = { ...editData, Cost: round2(cost), DateRequired: editData.DateRequired };
      this.clearLineAmounts(updatedProduct);
    } else {
      const gross = costCalculationType === 'Wgt' ? wgt * cost : lineAmount(qty, cost);
      const netAmount = netFromAmountAndPercent(gross, discPct);
      const gstSplit = gstOnNet(
        netAmount,
        _.toNumber(editData.GSTRate),
        this.isIGST,
        editData.IsTaxable
      );
      updatedProduct = {
        ...editData,
        Cost: round2(cost),
        ExtendedCost: round2(gross),
        NetAmount: round2(netAmount),
        LineTotal: lineTotalFromNetAndGst(netAmount, gstSplit),
        CGST: gstSplit.cgst,
        SGST: gstSplit.sgst,
        IGST: gstSplit.igst,
        SalesTax: gstSplit.gstTotal,
        DateRequired: editData.DateRequired,
      };
    }

    this.products[index] = updatedProduct;
    this.allProductData[index] = { ...updatedProduct };

    void this.calculateOrderTotal();
  }

  onReturnQuantityBlur(product: any) {
    if (product.ReturnQuantity === '' || product.ReturnQuantity === null || product.ReturnQuantity === undefined) {
      product.ReturnQuantity = product.previousReturnQuantity ?? 0;
    } else {
      product.previousReturnQuantity = product.ReturnQuantity;
      this.onProductEdit(product);
    }
  }

  resolveIsIGSTMode(silent = false): boolean {
    const wh = this.normalizeState(this.warehouseState);
    const ven = this.normalizeState(this.vendorState);

    if (wh && ven) {
      this.isIGST = wh.toLowerCase() !== ven.toLowerCase();
      return true;
    }

    const lines = this.products ?? [];
    if (lines.some((p) => (Number(p.IGST) || 0) > 0.0001)) {
      this.isIGST = true;
      return true;
    }
    if (lines.some((p) => (Number(p.CGST) || 0) + (Number(p.SGST) || 0) > 0.0001)) {
      this.isIGST = false;
      return true;
    }

    this.isIGST = false;
    if (!silent) {
      this.messageService.add({
        severity: 'warn',
        summary: 'GST mode',
        detail: 'Vendor or warehouse state is missing; intra-state GST (CGST/SGST) is assumed until states are set.',
      });
    }
    return true;
  }

  checkIGST(): boolean {
    return this.resolveIsIGSTMode(false);
  }


  calculateGST(price: number, quantity: number, gstrate: number, taxable: boolean, discount: number): number {
    if (taxable) {
      const gross = price * quantity;
      const discountAmount = gross * (discount / 100);
      const taxableAmount = gross - discountAmount;
      return taxableAmount * gstrate / 100;
    } else {
      return 0;
    }
  }


  async calculateOrderTotal() {
    this.resolveIsIGSTMode(true);

    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let quantityTotal = 0;
    let totalReturnNet = 0;

    for (let i = 0; i < this.products.length; i++) {
      const product = this.products[i];
      const qty = _.toNumber(product.ReturnQuantity);

      if (qty <= 0) {
        this.clearLineAmounts(product);
        continue;
      }

      const productId = _.toNumber(product.ProductId);
      let costCalculationType = 'Qty';
      try {
        const productData = await this.getProductById(productId);
        costCalculationType = productData.costCalculation || 'Qty';
      } catch (error) {
        console.error('Failed to fetch product data:', error);
        continue;
      }

      const wgt = _.toNumber(product.Weight) || 0;
      const cost = parseFloat(String(product.Cost).replace(/[₹,]/g, '')) || 0;
      const discPct = _.toNumber(product.Discount) || 0;
      const gross = costCalculationType === 'Wgt' ? wgt * cost : lineAmount(qty, cost);
      const netAmount = netFromAmountAndPercent(gross, discPct);
      const gstSplit = gstOnNet(
        netAmount,
        _.toNumber(product.GSTRate),
        this.isIGST,
        product.IsTaxable
      );

      product.ExtendedCost = round2(gross);
      product.NetAmount = round2(netAmount);
      product.LineTotal = lineTotalFromNetAndGst(netAmount, gstSplit);
      product.CGST = gstSplit.cgst;
      product.SGST = gstSplit.sgst;
      product.IGST = gstSplit.igst;
      product.SalesTax = gstSplit.gstTotal;

      if (this.isIGST) {
        igst += gstSplit.gstTotal;
      } else {
        cgst += gstSplit.cgst;
        sgst += gstSplit.sgst;
      }

      totalReturnNet += netAmount;
      quantityTotal += qty;
    }

    const lineNetTotal = round2(totalReturnNet);

    if (!this.skipFreightProration && this.grnChargeBaseline.lineNet > 0 && lineNetTotal > 0) {
      this.applyProratedFreightToForm(lineNetTotal);
    }

    const freightCharge = this.parseChargeInput(this.purchaseOrderForm.get('FreightAmount')?.value);
    const pfCharge = this.parseChargeInput(this.purchaseOrderForm.get('PackingForwarding')?.value);
    const freightGSTRate = this.num(this.purchaseOrderForm.get('GSTRateOnFreight')?.value);
    const pfGSTRate = this.num(this.purchaseOrderForm.get('GSTRateOnPNF')?.value);

    const freightForTotal = lineNetTotal > 0 ? freightCharge : 0;
    const pfForTotal = lineNetTotal > 0 ? pfCharge : 0;
    const freightGST =
      lineNetTotal > 0 ? round2((freightForTotal * freightGSTRate) / 100) : 0;
    const pfGST = lineNetTotal > 0 ? round2((pfForTotal * pfGSTRate) / 100) : 0;

    if (lineNetTotal > 0) {
      this.purchaseOrderForm.patchValue(
        { GSTOnFreight: freightGST, GSTOnPNFAmount: pfGST },
        { emitEvent: false }
      );
    }

    const extraGST = freightGST + pfGST;
    if (extraGST > 0) {
      if (this.isIGST) {
        igst += extraGST;
      } else {
        cgst = round2(cgst + extraGST / 2);
        sgst = round2(sgst + extraGST / 2);
      }
    }

    this.CGSTtotal = this.isIGST ? 0 : round2(cgst);
    this.SGSTtotal = this.isIGST ? 0 : round2(sgst);
    this.IGSTtotal = this.isIGST ? round2(igst) : 0;
    this.TaxTotal = round2(this.CGSTtotal + this.SGSTtotal + this.IGSTtotal);
    this.lineTaxableTotal = lineNetTotal;
    this.FinalTaxableAmt = round2(lineNetTotal + freightForTotal + pfForTotal);
    this.orderTotal = round2(this.FinalTaxableAmt + this.TaxTotal);
    this.weightTotal = quantityTotal;

    this.products = _.cloneDeep(this.products);
    this.POLineItemData = this.products;
    this.purchaseOrderForm.patchValue({
      poTotal: this.orderTotal,
      SGSTtotal: this.SGSTtotal,
      CGSTtotal: this.CGSTtotal,
      IGSTTotal: this.IGSTtotal,
      TaxTotal: this.TaxTotal,
      totalWeight: this.weightTotal,
      FinalTaxableAmt: this.FinalTaxableAmt,
      GSTOnFreight: freightGST,
      GSTOnPNFAmount: pfGST,
    }, { emitEvent: false });

    return true;
  }

  editPurchaseOrder() {
    this.route.queryParams.subscribe(params => {
      this.purchaseOrderId = params['returnPurchaseOrderId'];
      this.isEditMode = !!this.purchaseOrderId;

      if (this.isEditMode) {
        this.loader = true;

        this.porderservice.getPurchaseOrderRetunById(this.purchaseOrderId).subscribe(
          (purchaseOrder: any) => {
            if (purchaseOrder) {
              //console.log(purchaseOrder);

              this.loader = false;
              document.title = 'Update Purchase Return';
              const requestedDate = purchaseOrder.requestedDate ? new Date(purchaseOrder.requestedDate) : null;
              const createdDate = purchaseOrder.createdDate ? new Date(purchaseOrder.createdDate) : null;
              const returnDate = purchaseOrder.returnDate ? new Date(purchaseOrder.returnDate) : null;
              const challanDate = purchaseOrder.challanDate ? new Date(purchaseOrder.challanDate) : null;
              const receiveDate = purchaseOrder.receiveDate ? new Date(purchaseOrder.receiveDate) : null;

              const formPatch: any = {
                ...purchaseOrder,
                ...this.chargeFieldsFromApi(purchaseOrder),
                receiptNumber: purchaseOrder.receiptNumber ?? purchaseOrder.ReceiptNumber,
                poNumber: purchaseOrder.poNumber ?? purchaseOrder.PoNumber,
                departments: purchaseOrder.department?.departmentCode,
                PurchaseOrder_Status: purchaseOrder.purchaseOrder_Status,
                departmentName: purchaseOrder.department?.departmentName,
                warehouses: purchaseOrder.warehouse?.warehouseCode,
                warehouseName: purchaseOrder.warehouse?.warehouseName,
                vendorName: purchaseOrder.vendor?.vendorName,
                add: `${purchaseOrder.vendor?.address?.addressLine1 || ''}, ${purchaseOrder.vendor?.address?.city || ''}, ${purchaseOrder.vendor?.address?.state || ''}, ${purchaseOrder.vendor?.address?.country || ''}, ${purchaseOrder.vendor?.address?.zip || ''}`,
                requestedDate: requestedDate,
                createdDate: createdDate,
                returnDate: returnDate,
                challanDate: challanDate,
                receiveDate: receiveDate,
                termsCode: purchaseOrder.termsCode,
                warehouseCode: purchaseOrder.warehouse?.warehouseCode,
                warehouseAddress: `${purchaseOrder.warehouse?.address?.addressLine1 || ''}, ${purchaseOrder.warehouse?.address?.city || ''}, ${purchaseOrder.warehouse?.address?.state || ''}, ${purchaseOrder.warehouse?.address?.country || ''}, ${purchaseOrder.warehouse?.address?.zip || ''}`,
                Taxes: purchaseOrder.taxes,
                ProjectNo: purchaseOrder.projectNo,
                Delivery: purchaseOrder.delivery,
                Transport: purchaseOrder.transport,
                Validity: purchaseOrder.validity,
                specialInstruction: purchaseOrder.specialInstruction,
                FinancialYearId: purchaseOrder.financialYearId,
              };

              this.isGlPosted = !!(purchaseOrder.isGlPosted ?? purchaseOrder.IsGlPosted);
              if (this.isGlPosted) { this.loadGlEntries(); }

              if (purchaseOrder.projectBoMCode) {
                this.inventoryService.getProjectBomCode(purchaseOrder.projectBoMCode).subscribe(
                  (projectDetails: any) => {
                    formPatch.projectBOMCode = projectDetails?.projectBoMName || 'Unknown Project';
                    this.purchaseOrderForm.patchValue(formPatch);
                  },
                  (error: any) => {
                    console.log('Error fetching project details:', error);
                    formPatch.projectBOMCode = 'N/A';
                    this.purchaseOrderForm.patchValue(formPatch);
                  }
                );
              } else {
                formPatch.projectBOMCode = '';
                this.purchaseOrderForm.patchValue(formPatch);
              }

              if (purchaseOrder.purchaseOrder_Status == 'Draft') {
              }

              this.warehouseState = purchaseOrder.warehouse?.address?.state || '';
              this.vendorState = purchaseOrder.vendor?.address?.state || '';
              this.orderTotal = purchaseOrder.poTotal;
              this.weightTotal = purchaseOrder.totalWeight;
              this.TaxTotal = purchaseOrder.taxTotal;
              this.CGSTtotal = purchaseOrder.cgstTotal;
              this.SGSTtotal = purchaseOrder.sgstTotal;
              this.IGSTtotal = purchaseOrder.igstTotal;

              const chargeFields = this.chargeFieldsFromApi(purchaseOrder);
              this.isIGST = chargeFields.IGSTTotal > 0;
              this.FinalTaxableAmt = chargeFields.FinalTaxableAmt;
              this.FreightAmount = chargeFields.FreightAmount;
              this.PackingForwarding = chargeFields.PackingForwarding;
              this.lineTaxableTotal = 0;
              this.orderTotal = chargeFields.poTotal;
              this.TaxTotal = chargeFields.TaxTotal;
              this.CGSTtotal = chargeFields.CGSTtotal;
              this.SGSTtotal = chargeFields.SGSTtotal;
              this.IGSTtotal = chargeFields.IGSTTotal;
              this.weightTotal = chargeFields.totalWeight;

              this.grnChargeBaseline = {
                freight: this.FreightAmount,
                pf: this.PackingForwarding,
                freightRate: chargeFields.GSTRateOnFreight,
                pfRate: chargeFields.GSTRateOnPNF,
                lineNet: 0,
              };

              this.returnPurchaseOrderIds = purchaseOrder.returnPurchaseOrderId;
              this.receiptNumber = purchaseOrder.receiptNumber ?? purchaseOrder.ReceiptNumber;

              const finishEditLoad = () => {
                this.applySavedChargeFieldsFromApi(purchaseOrder);
                this.skipFreightProration = true;
                void this.calculateOrderTotal().finally(() => {
                  this.skipFreightProration = false;
                  this.applySavedChargeFieldsFromApi(purchaseOrder);
                });
              };

              const receiptNo = this.receiptNumber;
              if (receiptNo) {
                this.porderservice.getPOReceiptLineitem(receiptNo).subscribe({
                  next: (grnLines: any) => {
                    this.grnChargeBaseline.lineNet = this.computeGrnLineNetTotal(grnLines);
                  },
                });
              }

              this.porderservice.getPOLineitemById(this.returnPurchaseOrderIds).subscribe(
                (lineItemsData: any) => {
                  this.products = this.loadProducts(lineItemsData);
                  this.allProductData = this.products;
                  finishEditLoad();
                },
                (error: any) => {
                  console.log('Error fetching purchase order lineitems:', error);
                  finishEditLoad();
                }
              );
            } else {
              this.loader = false;
            }
          },
          (error: any) => {
            this.loader = false;
            console.log('Error fetching purchase order:', error);
          }
        );
      }
    });
  }

  async getProjectNameByBoMCode(projectBoMCode: string): Promise<string> {
    try {
      const response = await this.inventoryService.getProjectBomCode(projectBoMCode).toPromise();
      return response?.projectBoMName;
    } catch (error) {
      console.error("Error retrieving project name:", error);
      return 'Unknown Project';
    }
  }

  loadProducts(data: any): ProductPOReturn[] {
    const products: ProductPOReturn[] = data.map((item: any) => {
      return this.loadProduct(item);
    });

    products.sort((a, b) => {
      return a.LineItemNumber - b.LineItemNumber;
    });

    return products;
  }

  loadProduct(data: any) {
    const receivedQty = this.num(data.receivedQuantity);
    const rejectedQty = this.num(
      data.rejectedQuantity ?? data.RejectedQuantity ?? data.rejectedQty ?? data.RejectedQty
    );

    const hasSavedReturnQty = data.returnQuantity != null && data.returnQuantity !== '' && (this.isEditMode || this.num(data.purchaseOrderReturnLineItemId) > 0);
    const returnQty = hasSavedReturnQty ? this.num(data.returnQuantity) : 0;
    const cost = this.num(data.cost);
    const discount = this.num(data.discount);
    const gross = lineAmount(returnQty, cost);
    const netAmount = netFromAmountAndPercent(gross, discount);
    const gstSplit = gstOnNet(
      netAmount,
      this.num(data.gstRate),
      this.isIGST,
      isTaxableFlag(data.isTaxable)
    );

    const product: ProductPOReturn = <ProductPOReturn>{
      purchaseOrderReturnLineItemId: data.purchaseOrderReturnLineItemId,
      POReceiptLineItemId: data.poReceiptLineItemId,
      ReceiptNumber: data.poReceiptNumber,
      returnPurchaseOrderId: data.returnPurchaseOrderId,
      ProductId: data.productId,
      POQuantity: data.poQuantity,
      ReceivedQuantity: receivedQty,
      ReturnQuantity: returnQty,
      RejectedQuantity: rejectedQty,
      DateRequired: data.dateRequired ? new Date(data.dateRequired) : new Date(),
      Uom: data.uom,
      LineItemNumber: data.lineItemNumber,
      IsTaxable: isTaxableFlag(data.isTaxable),
      Cost: cost,
      Discount: discount,
      UnitPrice: data.unitPrice,
      projectBoMId: data.projectBoMId,
      projectBoMName: data.projectBOM?.projectBoMName,
      ExtendedCost: returnQty > 0 ? round2(gross) : 0,
      NetAmount: returnQty > 0 ? round2(netAmount) : 0,
      LineTotal: returnQty > 0 ? lineTotalFromNetAndGst(netAmount, gstSplit) : 0,
      GSTRate: this.num(data.gstRate),
      Weight: this.num(data.weight),
      HSNCode: data.hsnCode,
      CGST: returnQty > 0 ? gstSplit.cgst : 0,
      SGST: returnQty > 0 ? gstSplit.sgst : 0,
      IGST: returnQty > 0 ? gstSplit.igst : 0,
      ProductCode: data.productCode,
      ProductDescription: data.productDescription,
      ProductSpecification: data.productSpecification,
      Comment: data.comment,
      CreatedBy: data.createdBy,
      IsActive: true,
    };

    return product;
  }

  onReturnQtyChanged(product: ProductPOReturn): void {
    void this.onProductEdit(product);
  }

  glPostAfterApprove(returnPurchaseOrderId: number): void {
    const username = localStorage.getItem('username') ?? '';

    this.inventoryService.glPostPurchaseReturn(returnPurchaseOrderId, { createdBy: username })
      .subscribe({
        next: (glRes: any) => {
          this.handlePurchaseReturnGlPostResponse(glRes);
          setTimeout(() => {
            this.router.navigate(['/home/Return-PO-List']);
          }, 1000);
        },
        error: (err: any) => {
          const detail =
            err?.error?.message ??
            err?.error?.Message ??
            err?.message ??
            'GL posting error after Purchase Return close.';
          this.messageService.add({ severity: 'warn', summary: 'GL Pending', detail });
          console.error('Purchase Return GL error:', err);
          setTimeout(() => {
            this.router.navigate(['/home/Return-PO-List']);
          }, 1000);
        }
      });
  }

  private handlePurchaseReturnGlPostResponse(res: any): void {
    const ok = res?.success !== false && res?.Success !== false;
    const msg = (res?.message ?? res?.Message ?? '').toString();
    const entryCount = Number(res?.entriesCreated ?? res?.EntriesCreated ?? 0);

    if (ok && entryCount > 0) {
      this.isGlPosted = true;
      this.loadGlEntries();
      this.openGlPostingTab();
      this.messageService.add({
        severity: 'success',
        summary: 'GL Posted',
        detail: msg || `GL posted successfully (${entryCount} entries).`
      });
      return;
    }
    if (ok && msg.toLowerCase().includes('already')) {
      this.isGlPosted = true;
      this.loadGlEntries();
      this.messageService.add({ severity: 'info', summary: 'GL', detail: msg });
      return;
    }
    if (ok && (msg.toLowerCase().includes('zero') || msg.toLowerCase().includes('skipped'))) {
      this.messageService.add({ severity: 'info', summary: 'GL', detail: msg });
      return;
    }
    if (!ok) {
      this.messageService.add({
        severity: 'warn',
        summary: 'GL Pending',
        detail: msg || 'Return saved but GL posting did not complete.'
      });
    }
  }

  loadGlEntries(): void {
    const id = Number(this.returnPurchaseOrderIds ?? this.purchaseOrderId);
    if (!id) return;

    this.inventoryService.getGlEntriesForPurchaseReturn(id).subscribe({
      next: (res: any) => {
        const entries = res?.entries ?? res?.Entries;
        if (entries) {
          this.glEntries = this.mapGlEntriesForDisplay(entries);
          this.glTotalDebit = Number(res.totalDebit ?? res.TotalDebit ?? 0);
          this.glTotalCredit = Number(res.totalCredit ?? res.TotalCredit ?? 0);
          this.isGlPosted = this.isGlPosted || this.glEntries.length > 0;
        }
      },
      error: () => {
        this.glEntries = [];
        this.glTotalDebit = 0;
        this.glTotalCredit = 0;
      }
    });
  }

  openGlPostingTab(): void {
    if (this.isGlPosted) {
      this.activeIndex = 2;
    }
  }

  formatGlAmount(value: number | null | undefined): string {
    return Number(value || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  private mapGlEntriesForDisplay(entries: any[]): any[] {
    return (entries ?? []).map((e: any) => ({
      accountCode: e.accountCode ?? e.AccountCode ?? '',
      accountName: e.accountName ?? e.AccountName ?? '',
      debitAmount: Number(e.debitAmount ?? e.DebitAmount ?? 0),
      creditAmount: Number(e.creditAmount ?? e.CreditAmount ?? 0),
      warehouseName: e.warehouseName ?? e.WarehouseName ?? '',
      departmentName: e.departmentName ?? e.DepartmentName ?? '',
      postedDate: e.postedDate ?? e.PostedDate ?? null,
    }));
  }

  onReturnQuantityChange(index: number, newReturnQty: number) {
    if (index >= 0 && index < this.products.length) {
      const product = this.products[index];
      const returnQty = Number(newReturnQty) || 0;
      const rejectedQty = Number(product.RejectedQuantity) || 0;
      const receivedQty = Number(product.ReceivedQuantity) || 0;
      const maxAllowedQty = rejectedQty > 0 ? rejectedQty : receivedQty;

      if (returnQty > maxAllowedQty) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: `Return quantity (${returnQty}) cannot exceed ${rejectedQty > 0 ? 'rejected' : 'received'} quantity (${maxAllowedQty}) for product ${product.ProductCode}`
        });
        product.ReturnQuantity = Math.min(returnQty, maxAllowedQty);
        return;
      }

      product.ReturnQuantity = returnQty;
      this.checkIGST();
      void this.onProductEdit(product);
    }
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  viewProduct(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;

    const ref = this.dialogService.open(viewproductLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: productDataJson,
        productId: this.productId
      }
    });
    let messageShown = false;

    ref.onClose.subscribe(updatedProduct => {
      if (updatedProduct && !messageShown) {
        this.updateProductInGrid(productData, updatedProduct);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Product updated successfully.`
        });
        messageShown = true;
      }
    });
  }
  updateProductInGrid(originalProduct: any, updatedProduct: any) {
    originalProduct.ProductCode = updatedProduct.ProductCode;
    originalProduct.ProductDescription = updatedProduct.ProductName;
    originalProduct.Uom = updatedProduct.unitsofMeasure || updatedProduct.UnitsOfMeasure;
    originalProduct.HSNCode = updatedProduct.HSNCode;
    originalProduct.GSTRate = updatedProduct.gstRate;
    originalProduct.Cost = updatedProduct.StandardCost;
    originalProduct.ExtensionPrice = updatedProduct.
      SalesPrice * originalProduct.POQuantity;
    originalProduct.ProductSpecification = updatedProduct.ProductSpecification;
    const quantity = +originalProduct.POQuantity || 0;
    const cost = +originalProduct.Cost || 0;
    const gstRate = +updatedProduct.gstRate || 0;

    const baseCost = quantity * cost;

    const discountRate = +originalProduct.Discount || 0;
    const discountAmount = +(baseCost * (discountRate / 100)).toFixed(2);
    const taxableAmount = +(baseCost - discountAmount).toFixed(2);

    let cgst = 0, sgst = 0, igst = 0;

    if (this.isIGST) {
      igst = +(taxableAmount * gstRate / 100).toFixed(2);
    } else {
      const halfRate = gstRate / 2;
      cgst = +(taxableAmount * halfRate / 100).toFixed(2);
      sgst = +(taxableAmount * halfRate / 100).toFixed(2);
    }

    const totalTax = +(cgst + sgst + igst).toFixed(2);

    const totalWithTax = +(taxableAmount + totalTax).toFixed(2);

    originalProduct.CGST = cgst;
    originalProduct.SGST = sgst;
    originalProduct.IGST = igst;
    originalProduct.SalesTax = totalTax;
    originalProduct.TaxableAmount = taxableAmount;
    originalProduct.TotalWithTax = totalWithTax;
    originalProduct.ExtendedCost = round2(baseCost);
    originalProduct.NetAmount = round2(taxableAmount);
    originalProduct.LineTotal = round2(totalWithTax);

    this.products = [...this.products];

    this.calculateOrderTotal();
  }


  private normalizeProductIdInPlace(product: any): any {
    if (product && product.ProductId) {
      product.productId = product.ProductId;
      delete product.ProductId;
    }

    return product;
  }

  getUserList(): void {
    if (this.isEditMode) {
      return;
    }
    this.loader = true;
    this.warehouseService.getAllUser().subscribe({
      next: (data: any) => {
        this.userList = data;
        // this.setWarehouseFromSession();
        this.loader = false;
      },
      error: error => {
        console.error('Error fetching user info:', error);
        this.loader = false;
      }
    });
  }

  setWarehouseFromSession(): void {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData.user?.id;

    const user = this.userList.find((u: { userId: number; warehouseId?: number }) => u.userId === userId);
    if (user) {
      const warehouseId = user.warehouseId;
      if (warehouseId) {
        this.purchaseOrderForm.controls.warehouseId.setValue(warehouseId);

        this.setWarehouseName(warehouseId);

        this.setPurchaseOrderNumber(warehouseId);
      } else {
        console.warn(`No warehouse ID found for user ID: ${userId}`);
      }
    } else {
      console.warn(`User not found with user ID: ${userId}`);
    }
  }

  setPurchaseOrderNumber(warehouseId: number): void {
    const selectedWarehouse = this.warehouseDropdown.find(
      (warehouse: { warehouseId: number }) => warehouse.warehouseId === warehouseId
    );

    if (selectedWarehouse) {
      const unitSerial = selectedWarehouse.unitSerial;
      this.purchaseOrderForm.controls['unitSerial'].setValue(unitSerial);

    } else {
      console.warn(`Warehouse not found for warehouse ID: ${warehouseId}`);
    }
  }


  setWarehouseName(warehouseId: number): void {
    const warehouse = this.warehouseDropdown.find(w => w.warehouseId === warehouseId);
    if (warehouse) {
      this.purchaseOrderForm.controls.warehouseName.setValue(warehouse.warehouseName);
      const address = `${warehouse.address.addressLine1}, ${warehouse.address.city} , ${warehouse.address.state} , ${warehouse.address.country} , ${warehouse.address.zip}`;
      this.purchaseOrderForm.controls.warehouseAddress.setValue(address);
      this.warehouseState = warehouse.address.state;
    }
  }
  async toggleEdit(product: ProductPOReturn, field: 'Weight' | 'Quantity') {
    try {
      const productData = await this.getProductById(product.ProductId);
      const costCalculationType = productData.costCalculation || 'Qty';
      this.isEditingQuantity = false;
      this.isEditingWeight = false;
      if (costCalculationType === 'Qty' && field === 'Quantity') {
        this.isEditingQuantity = true;
      } else if (costCalculationType === 'Wgt' && field === 'Weight') {
        this.isEditingWeight = true;
      }

    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }

  getFormControlName(): string {
    return this.productCostCalculationType === 'Qty' ? 'productQty' : 'productWgt';
  }


  onKeydown(event: KeyboardEvent, product: any) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      this.onProductEdit(product);
      if (event.key === 'Tab') {
        this.moveFocusToNextField(event, product);
      }
    }
  }

  moveFocusToNextField(event: KeyboardEvent, product: any) {
    const inputs = document.querySelectorAll('input');
    const currentIndex = Array.from(inputs).indexOf(event.target as HTMLInputElement);
    const nextInput = inputs[currentIndex + 1] as HTMLInputElement;

    if (nextInput) {
      nextInput.focus();
    }
  }

  showComment(productItem: ProductPOReturn) {
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'Purchase Order Line Remark',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onProductEdit(productItem);
      }
    });
  }

  openLinkedFiles() {
    if (this.ref) {
      this.ref.close();
    }
    const orderNo = this.purchaseOrderForm.controls.receiptNumber.value;
    this.ref = this.dialogService.open(ListLinkedFilesLookupComponent, {
      header: `Linked File For Order ${orderNo}`,
      width: '60%',
      data: { orderNo: orderNo }
    });
  }

  createQuickVendor() {
    this.ref = this.dialogService.open(CloseQuickVendorLookupComponent, {
      header: 'Create Quick Vendor',
      width: '70%',

    });
    this.ref.onClose.subscribe((vendorId: number) => {
      if (vendorId) {
        this.getVendorData(vendorId);
      }
    });
  }

  getVendorData(id: number) {
    this.vendorService.getVendorById(id).subscribe(
      (data: any) => {
        const VendorData = {
          value: data
        }
        this.setVendor(VendorData)
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching vendor data.' });
      }
    );
  }

  showProductUom(productItem: ProductPOReturn) {
    this.ref = this.dialogService.open(UOMLookupComponent, {
      header: 'Unit of Measure',
      width: '60%',

    });
    this.ref.onClose.subscribe((selectedUOM: UnitsOfMeasure) => {
      if (selectedUOM) {
        productItem.Uom = selectedUOM.unitsofMeasure;
        this.onProductEdit(productItem);
      }
    });
  }

  showSpecification(productItem: any) {
    this.ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Order Line Specification',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        productItem.ProductSpecification = data.ProductSpecification;
        this.onProductEdit(productItem);
      }
    });
  }

  getInventoryStatus(productCode: string) {
    const warehouseId = this.purchaseOrderForm.value.warehouseId;
    if (!warehouseId) {
      return;
    }
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if (data.success === false) {
        } else {
          const inventoryItem = data.find((item: { warehouseId: any; }) => item.warehouseId === warehouseId);
          if (inventoryItem) {
            this.QAvail = inventoryItem.quantityAvailable;
          } else {
            console.log(`No inventory item found for warehouse ID: ${warehouseId}`);
          }
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getProduct() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({

        })
      }
    })
  }

  resetForm() {
    this.products = [];
  }



  getUnitLabel(): void {
    this.loader = true;
    const appKey = 'unitNameLabel';

    this.inventoryService.getUnitByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response?.appKeycode === appKey) {
          this.unitLabel = response?.data;
        } else {
          this.unitLabel = 'Unit';
        }
      },
      error: error => {
        console.error('Error fetching Unit Label:', error);
        this.unitLabel = 'Unit';
        this.loader = false;
      }
    });
  }


  getDeptLabel(): void {
    this.loader = true;
    const appKey = 'DeptLabel';

    this.inventoryService.getDeptByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response?.appKeycode === appKey) {
          this.DeptLabel = response?.data;
        } else {
          this.DeptLabel = 'Department';
        }
      },
      error: error => {
        console.error('Error fetching Department Label:', error);
        this.DeptLabel = 'Department';
        this.loader = false;
      }
    });
  }

  currentFinancialYear: any;

  loadCurrentFinancialYear() {
    this.salesService.getCurrentFinancialYear().subscribe({
      next: (response: any) => {
        //console.log(response.data.fyName);

        if (!response.data) {

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            // detail: 'No open Financial Year found for current date.'
            detail: 'No Open Financial Year is available for the current date. Please contact your administrator.'
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.purchaseOrderForm.patchValue({
          FinancialYearId: this.currentFinancialYear.fyId
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No open Financial Year found.'
        });
      }
    });
  }

  validateFinancialYear(): boolean {

    const orderDate = this.purchaseOrderForm.controls.returnDate.value;

    if (!orderDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Return Date required'
      });
      return false;
    }


    const fy = this.currentFinancialYear;

    if (!fy) {
      this.messageService.add({
        severity: 'error',
        summary: 'Financial Year',
        detail: 'No active Financial Year found.'
      });
      return false;
    }


    // LOCK CHECK
    if (fy.status === "Locked") {

      this.messageService.add({
        severity: 'error',
        summary: 'Locked FY',
        //detail: 'Financial Year is Locked.'
        detail: `Financial Year ${fy.fyName} is Locked.`
      });

      return false;
    }


    // CLOSED CHECK
    if (fy.status === "Closed") {

      this.messageService.add({
        severity: 'error',
        summary: 'Closed FY',
        //detail: 'Financial Year is Closed.'
        detail: `Financial Year ${fy.fyName} is Closed.`
      });

      return false;
    }


    const startDate = new Date(fy.startDate);
    const endDate = new Date(fy.endDate);


    // ORDER DATE CHECK

    const order = new Date(orderDate);

    if (order < startDate || order > endDate) {

      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Return Date',
        // detail: 'Order Date is outside Financial Year.'
        //summary: 'Invalid Transaction Date',
        detail:
          `Please select a Return date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });

      return false;
    }



    return true;
  }

  formatDate(date: Date): string {

    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

  }

  onTransactionDateChange(date: Date) {
    if (!date) {
      this.currentFinancialYear = null;

      this.purchaseOrderForm.patchValue({
        FinancialYearId: null
      });

      return;
    }

    this.salesService.getFinancialYearByDate(date).subscribe({
      next: (response: any) => {
        //console.log("API Response:", response);
        if (!response.success || !response.data) {
          this.currentFinancialYear = null;

          this.purchaseOrderForm.patchValue({
            FinancialYearId: null
          });

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            detail: 'No Open Financial Year found for the selected Received Date.'
          });
          return;
        }

        this.currentFinancialYear = response.data;
        // console.log("Current Financial Year ID:", response.data.fyId);//3
        this.purchaseOrderForm.patchValue({
          FinancialYearId: response.data.fyId
        });
        //console.log("Patch Financial Year ID:", this.createOrderForm.controls['FinancialYearId'].value);
      },

      error: () => {
        this.currentFinancialYear = null
        this.purchaseOrderForm.patchValue({
          FinancialYearId: null
        });

        this.messageService.add({
          severity: 'error',
          summary: 'Financial Year',
          detail: 'Unable to fetch Financial Year.'
        });

      }

    });
  }



}


